import type { InternalAxiosRequestConfig } from "axios";

import { useAdminStore } from "@/stores";

export const privateRequest = (config: InternalAxiosRequestConfig) => {
  const { token } = useAdminStore.getState();

  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }

  return config;
};
